




























import { Component, Vue, Prop } from "vue-property-decorator";
import requestService from "@/service/requestService";
import loadingService from "@/service/loadingService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import { MESSAGE } from "@/model/Message";
import { Action, Getter } from "vuex-class";
import { InspectionShakenShuruiDetailStoreService } from "@/service/InspectionShakenShuruiDetailStoreService";

@Component({
  components: {
  }
})
export default class SknMenuDialog extends Vue {

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("sknSeibiShubetsuKbn", { namespace: "ReservationDetail" })
  sknSeibiShubetsuKbn: number;
  @Getter("isUseIppanSeibi", { namespace: "FunctionSetting" })
  isUseIppanSeibi: boolean | null; // システム設定A 一般整備見積

  reqService: requestService;
  loadingService: loadingService = new loadingService();
  ippanSeibiService: IppanSeibiService = new IppanSeibiService();
  inspectionDetailStoreService1: InspectionShakenShuruiDetailStoreService =
    new InspectionShakenShuruiDetailStoreService();
  showDialog: boolean = false;
  errorMessage: string = "";

  shakenShurui: any = [];

  private shakenShuruiPromise: Promise<void> | null = null; // promise

  $refs!: {
  };

  created() {
    this.reqService = new requestService();
    this.getShakenShurui();
  }


  async getShakenShurui() {
    if (this.shakenShuruiPromise) { return this.shakenShuruiPromise; }

    this.shakenShuruiPromise = (async () => {
      try {
        const res: any = await this.reqService.getSeibiMenuList();
        const shakenShuruiSeibiMenuCd = this.seibiMenuCd;
        const isSaved = shakenShuruiSeibiMenuCd != "";
        const isSeibifilter = ( this.isUseIppanSeibi 
          && this.sknSeibiShubetsuKbn != null && this.sknSeibiShubetsuKbn > -1);

        const seibiShubetsuList = res
          .filter((e: any) => {
            // 一般整備有効時のコースフィルタリング
            // 車検(=0)は車検、整備(>0)は整備で同じ整備種別の車検種類をリストアップする
            if (!isSeibifilter) { return true; }
            return this.sknSeibiShubetsuKbn == e.sknSeibiShubetsuKbn;
          })
          .map((data: any) => {
            const selected =
              isSaved && shakenShuruiSeibiMenuCd == data.seibiMenuCd 
                ? "1"
                : "0";
            data.delKbn = ( selected === "1" && data.delKbn == "9" )? "-1": data.delKbn;
            return { ...data, selected };
          });
        
        // 削除済みの車検種類を選択している場合のフォロー動作
        if ( this.seibiMenuCd != 0 ) {
          const selectedData = seibiShubetsuList.filter( (data: any) => data.selected === "1");
          if (!selectedData || selectedData.length == 0) {
            /** 
             * 通常の選択ではここには来ない。
             * 過去の車検データを再閲覧時に選択した車検種類が削除済みの時の処理
             * 削除された車検種類のデータはないので表示用のデータを生成、追加する
             */
            // 項目の追加と選択
            let deletedNode: any = {
              delKbn: "-1",
              displayOrder: null,
              isShaken: null,
              seibiMenuCd: this.seibiMenuCd,
              seibiMenuNm: this.sknSeibiShubetsuKbn && this.sknSeibiShubetsuKbn > 0?"削除済み整備種類":"削除済み車検種類",
              selected: "1",
              sknSeibiShubetsuKbn: this.sknSeibiShubetsuKbn && this.sknSeibiShubetsuKbn > 0?1:0
            };
            seibiShubetsuList.push(deletedNode);
          //  this.nowSelected[0] = true;
          }
        }

        this.$set(this, "shakenShurui", seibiShubetsuList);
      } catch (err) {
        this.$set(this, "shakenShurui", []);
      } finally {
        this.shakenShuruiPromise = null;
      }
    })();

    return this.shakenShuruiPromise;
  }

  selShakenShurui(code: string) {
    this.shakenShurui.map((data: any) => {
      if (data.seibiMenuCd == code) {
        if (data.selected == "1") {
          /** 2022-12-19 sh #8140(BQR986-2) ommit. [START] */
          /** 未選択の状態にすることはないので、0に戻せないようにする */
          // data.selected = "0";
          /** 2022-12-19 sh #8140(BQR986-2) ommit. [END] */
        } else {
          data.selected = "1";
        }
      } else {
        data.selected = "0";
      }
    });
  }

  onOpen() {
    this.showDialog = true;
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    this.$nextTick(()=> {
      this.selShakenShurui(this.seibiMenuCd);
    });
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
    this.errorMessage = "";
  }

  onClose() {
    this.setLoading(false);
    this.showDialog = false;
  }

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  setLoading(b: any) {
    if (b) {
      this.loadingService.show();
    } else {
      this.loadingService.hide();
    }
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  onConfirm() {
    let saveFlg = false;
    let seibiMenuCd = '';
    let seibiMenuNm = '';
    this.shakenShurui.forEach((element: any) => {
      if (element.seibiMenuCd != this.seibiMenuCd && element.selected == "1") {
        seibiMenuCd = element.seibiMenuCd;
        seibiMenuNm = element.seibiMenuNm;
        saveFlg = true;
      }
    });
    if (saveFlg) { this.$emit('onConfirm', seibiMenuCd , seibiMenuNm ); }
  }

  get seibiMenuCd(): any {
    return this.inspectionDetailStoreService1.seibiMenuCd;
  }
}
